import React, {Component} from 'react';
import {Alert, Button, CardTitle, Col, Container, FormGroup, Input, Modal, Row} from 'reactstrap';
import auditService from "../../../services/auditService";
import FormInput from "../../../components/common/form/FormInput";
import _ from 'lodash';
import NotificationAlert from "react-notification-alert";
import Loader from "../../Loader";
import FormReactSelect from "../../../components/common/form/FormReactSelect";
import countries from "../../../util/countriesGlobal";

const scoreLabels = {
    0: "Very Poor",
    1: "Poor",
    2: "Fair",
    3: "Average",
    4: "Good",
    5: "Very Good",
    6: "Excellent"
};

class AuditForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            survey: props.surveyDetails || [],
            answers: {},
            submitted: false,
            error: '',
            validation: '',
            contactUsModal: false,
            name: null,
            email: null,
            title: null,
            lastName: null,
            firstName: null,
            contactNumber: null,
            country: null,
            groupedObjects: {},
            contactCaptured: false,
            selectedCountry: {},
            loading: false
        };
    }

    componentDidMount() {
        auditService.listQuestions().then((response) => {
            console.log(response);
            const groupedObjects = _.groupBy(response, "category")
            console.log("groupedObjects", groupedObjects)
            this.setState({survey: response, groupedObjects: groupedObjects});
        });
        if (localStorage.getItem("userId")) {
            this.setState({contactCaptured: true})
        } else {
            this.toggleModal("contactUsModal")
        }
    }

    notify = (type, title, message) => {
        let options = {
            place: "tc",
            message: (
                <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}
          </span>
                    <span data-notify="message">{message}</span>
                </div>
            ),
            type: type,
            icon: "ni ni-bell-55",
            autoDismiss: 5,
        };
        this.refs.notificationAlert.notificationAlert(options);
    };


    handleChange = (questionId, score) => {
        this.setState(prevState => ({
            answers: {
                ...prevState.answers,
                [questionId]: score
            }
        }));
    };

    toggleModal = (stateKey) => {
        this.setState(prevState => ({
            [stateKey]: !prevState[stateKey]
        }));
    };

    handleSubmit = (e) => {

        e.preventDefault();
        const {survey, answers} = this.state;

        if (survey.length === 0) {
            this.setState({error: 'No questions available.'});
            return;
        }

        const unanswered = survey.some(q => !(q.uniqueId in answers));
        if (unanswered) {
            this.setState({error: 'Please answer all questions.'});
            return;
        }

        this.setState({error: ''});
        this.submitQuery()
    };

    handleInputChange = (e) => {
        const {name, value} = e.target;
        this.setState({[name]: value});
    };

    submitQuery = () => {
        this.setState({loading: true})
        const answerArray = this.state.survey.map(q => ({
            questionId: q.uniqueId,
            score: this.state.answers[q.uniqueId]
        }));
        const {name, email, contactNumber} = this.state;
        console.log("Query submitted:", {name, email, contactNumber, answerArray});
        const data = {
            email: this.state.email,
            title: this.state.title,
            lastName: this.state.lastName,
            firstName: this.state.firstName,
            country: this.state.country,
            contactNumber: this.state.contactNumber,
            answers: answerArray
        }
        auditService.submitQuestionaire(data).then(res => {
            console.log(res);
            this.setState({submitted: true})
            this.setState({loading: false})
        }).catch(reason => {
            console.log(reason);
            this.setState({loading: false})
        })
    };

    captureContact = () => {
        const {name, email, contactNumber, title, lastName, firstName, country} = this.state;
        console.log(this.state)
        this.setState({validation:''})
        if (firstName && lastName && title && email && contactNumber && country) {
            this.setState({contactCaptured: true})
            this.toggleModal("contactUsModal");
        } else {
            this.setState({validation:'All fields are mandatory to proceed!'})
            setTimeout(
                () => {this.setState({validation:''})},3000
            )
        }
    };

    handleCountrySelectChange = (valueObj) => {
        if (_.isNull(valueObj)) {
            this.setState({selectedCountry: {}, country: ""});
        } else {
            this.setState({selectedCountry: valueObj, country: valueObj.key});
        }
    }


    render() {
        const {
            survey,
            answers,
            submitted,
            error,
            contactUsModal,
            name,
            email,
            contactNumber,
            groupedObjects,
            title,
            lastName,
            firstName
        } = this.state;

        if (submitted) {
            return (
                <Container className="mt-4">
                    <Alert color="success">
                        <h4 className="alert-heading">Thank you!</h4>
                        <p>Your responses have been recorded successfully. We will share the findings with you over the
                            email.</p>
                    </Alert>
                </Container>
            );
        }

        return (
            <Container className="mt-4">
                {this.state.loading && <Loader/>}
                <div className="rna-wrapper">
                    <NotificationAlert ref="notificationAlert"/>
                </div>
                <h2 className="mb-4">Please rate each statement below on a scale from 0 to 5, where 0 means Strongly
                    Disagree and 5 means Strongly Agree.</h2>
                {this.state.contactCaptured && <>
                    <form onSubmit={this.handleSubmit}>
                        {Object.entries(groupedObjects).map(([category, questions]) => (
                            <div key={category}>
                                <CardTitle tag="h3" className="mt-4 mb-3">{category}</CardTitle>
                                {Array.isArray(questions) && questions.length > 0 && questions.map((q, index) => (
                                    <Row>
                                        <Col md="12" key={q.uniqueId} className="mb-3">
                                            <Row>
                                                <Col md={8}>
                                                    <p tag="h4">{index + 1}. {q.question}</p>
                                                </Col>
                                                <Col md={4}>
                                                    <FormGroup row className="mt-0">
                                                        {[0, 1, 2, 3, 4, 5].map(score => (
                                                            <Col key={score} className="text-center">
                                                                <div style={{
                                                                    marginBottom: '4px',
                                                                    fontWeight: '500',
                                                                    marginLeft: '-20px'
                                                                }}>{score}</div>
                                                                <Input
                                                                    type="radio"
                                                                    name={`question-${q.uniqueId}`}
                                                                    value={score}
                                                                    checked={answers[q.uniqueId] === score}
                                                                    onChange={() => this.handleChange(q.uniqueId, score)}
                                                                    style={{
                                                                        borderRadius: '50%',
                                                                        width: '1.25rem',
                                                                        height: '1.25rem'
                                                                    }}
                                                                />
                                                            </Col>
                                                        ))}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                ))}
                            </div>))}

                        {error && <Alert color="danger">{error}</Alert>}
                        <div className="text-center">
                            <Button color="default" outline={true} type="submit">Submit</Button>
                        </div>
                    </form>
                </>}

                <Modal
                    className="modal-dialog-centered"
                    isOpen={contactUsModal}
                    toggle={() => this.toggleModal("contactUsModal")}
                >
                    <div className="modal-header">
                        <h5 className="modal-title" id="contactUsModalLabel">
                            Please provide us your contact details/email address to share the findings with you.
                        </h5>
                        {/*<button
                            aria-label="Close"
                            className="close"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => this.toggleModal("contactUsModal")}
                        >
                            <span aria-hidden={true}>×</span>
                        </button>*/}
                    </div>
                    <div className="modal-body">
                        <Row>
                            <Col md="12">
                                <FormInput
                                    name="firstName"
                                    className="form-control-label"
                                    id="firstName"
                                    placeholder="inputPlaceHolder.contact.firstName"
                                    type="text"
                                    onChange={this.handleInputChange}
                                    label="inputLabel.contact.firstName"
                                    value={firstName}
                                    required
                                />
                            </Col>
                            <Col md="12">
                                <FormInput
                                    name="lastName"
                                    className="form-control-label"
                                    id="lastName"
                                    placeholder="inputPlaceHolder.contact.lastName"
                                    type="text"
                                    onChange={this.handleInputChange}
                                    label="inputLabel.contact.lastName"
                                    value={lastName}
                                    required
                                />
                            </Col>
                            <Col md="12">
                                <FormInput
                                    name="title"
                                    className="form-control-label"
                                    id="title"
                                    placeholder="inputPlaceHolder.contact.title"
                                    type="text"
                                    onChange={this.handleInputChange}
                                    label="inputLabel.contact.title"
                                    value={title}
                                    required
                                />
                            </Col>
                            <Col md="12">
                                <FormInput
                                    name="email"
                                    className="form-control-label"
                                    id="email"
                                    placeholder="Email address"
                                    type="email"
                                    onChange={this.handleInputChange}
                                    label="Email Address"
                                    value={email}
                                    required
                                />
                            </Col>
                            <Col md="12">
                                <FormInput
                                    name="contactNumber"
                                    className="form-control-label"
                                    id="contactNumber"
                                    placeholder="Contact Number"
                                    type="text"
                                    onChange={this.handleInputChange}
                                    label="Contact Number"
                                    value={contactNumber}
                                    required
                                />
                            </Col>
                            <Col md={12}>
                                <FormGroup>
                                    <FormReactSelect
                                        selectKey={this.state.selectKey}
                                        isMulti={false}
                                        className="form-control-label"
                                        isSearchable={true}
                                        label="Country"
                                        name={"country"}
                                        onChange={this.handleCountrySelectChange}
                                        optionValue={"value"}
                                        defaultValue={this.state.selectedCountry}
                                        optionList={countries}
                                        optionLabel={"key"}
                                        placeHolder="Country"
                                        errorMsg={this.state?.errorObj?.country || ""}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>
                    <div className="modal-footer">
                        {this.state.validation && <Alert color="danger">{this.state.validation}</Alert>}
                        <Button color="default" type="button" outline onClick={this.captureContact}>
                            Submit
                        </Button>
                    </div>
                </Modal>
            </Container>
        );
    }
}

export default AuditForm;
